<template>
    <sub-page class="m-omitUserDetail" :title="`${name}的漏检历史记录`" :closeBtn="true">
        <div class="detail-table relative">
            <data-tables :data="tableData"
                         :table-props="tableProps"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
            >
                <el-table-column type="index" width="40" align="center"></el-table-column>
                <el-table-column v-for="(title, index) in titles" :prop="title.prop" :label="title.label" :key="index"
                                 align="center"
                                 show-overflow-tooltip
                                 :sortable="title.sortable">
                    <template v-if="title.prop==='imageUrl'" #default="{row}">
                        <div class="img-map">
                            <img :src="row.imageUrl" alt="">
                        </div>
                    </template>
                </el-table-column>
            </data-tables>
        </div>

        <el-row :gutter="20" class="mt20">
            <el-col :span="16" class="relative">
                <stats-chart ref="countChart" type="line" title="近一周漏检图像数量" />
            </el-col>

            <el-col :span="8" class="relative">
                <stats-chart ref="timeChart" type="pie" title="漏检时间段统计" />
            </el-col>
        </el-row>

        <el-row :gutter="20" class="mt10">
            <el-col :span="16" class="relative">
                <stats-chart ref="categoryChart" type="bar" title="近一周漏检图像种类排行" />
            </el-col>

            <el-col :span="8" class="relative">
                <stats-chart ref="abilityChart" type="radar" title="个人能力分析" />
            </el-col>
        </el-row>

    </sub-page>
</template>

<script>
    import SubPage from '@/components/Subpage.vue'
    import uiCard from '@/components/Statistics/StatisticUICard.vue'
    import StatsChart from "@/components/Statistics/StatsChart"

    export default {
        props: ['userID', 'name'],
        components: {
            SubPage,
            uiCard,
            StatsChart
        },
        data() {
            return {
                tableData: [],
                tableProps: {
                    border: false,
                    stripe: true,
                    height: 360
                },
                titles: [
                    {
                        prop: 'createTime',
                        label: '漏检时间',
                        sortable: 'custom'
                    }, {
                        prop: 'knowledgeName',
                        label: '漏检物品',
                    }, {
                        prop: 'imageUrl',
                        label: '漏检图像',
                    }, {
                        prop: 'channelTypeName',
                        label: '通道类型',
                        sortable: 'custom'
                    }, {
                        prop: 'passengerName',
                        label: '旅客姓名',
                    }, {
                        prop: 'flight',
                        label: '航班号',
                    }, {
                        prop: 'flightNatureName',
                        label: '航班性质',
                    }
                ],
            }
        },

        mounted() {
            this.getTableData()
            this.getChartData()
        },

        methods: {
            async getTableData() {
                let res = await this.$api.queryUserOmitDetail(this.userID)
                this.tableData = res.package
            },

            getChartData() {
                // 近一周漏检图像数量
                this.$api.knowledgeOmitNumber(this.userID).then(res => {
                    let data = res.package
                    this.$refs.countChart.drawChart({
                        data,
                        name: ['漏检图像数量'],
                        yAxis: {
                            splitLine: { //坐标轴在 grid 区域中的分隔线。
                                show: true,
                                lineStyle: {
                                    color: '#eee',
                                }
                            },
                        },
                        series: {
                            lineStyle: {
                                color: '#7DCFFE',
                            },
                            areaStyle: {
                                color: 'rgba(65,190,255,.3)'
                            },
                            markLine: {
                                data: [
                                    {type: 'average', name: '平均值'}
                                ]
                            }
                        }
                    })
                })

                // 漏检时间段统计
                this.$api.flightNatureTop(this.userID).then(res => {
                    let data = res.package.map(item => {
                        item.name = item.name || '未设置'
                        return item
                    })
                    this.$refs.timeChart.drawChart({
                        data,
                        name: ['时间段'],
                    })
                })

                // 个人能力分析
                this.$api.userOmitAbility(this.userID).then(res => {
                    let data = res.package

                    this.$refs.abilityChart.drawChart({
                        data,
                        name: '个人漏检情况',
                        tooltip: {
                            confine: true,
                            textStyle: {
                                fontSize: 12
                            },
                        }
                    })
                })

                // 近一周漏检图像种类排行
                this.$api.knowledgeOmitTop(this.userID).then(res => {
                    let data = res.package

                    this.$refs.categoryChart.drawChart({
                        data,
                        series: {
                            name: '图像数量',
                            type: 'bar',
                            label: {
                                show: true,
                                position: 'insideRight',
                                fontSize: 14,
                                offset: [-10, 0],
                            },
                        },
                        reverse: true
                    })
                })
            }
        },
    }
</script>

<style lang="scss">

    .m-omitUserDetail {
        .img-map {
            img {
                max-height: 100px;
                cursor: pointer;
            }
        }

        .el-table__body-wrapper {
            overflow-y: auto;
        }
    }
</style>
